import { render, staticRenderFns } from "./createNxOrder3.vue?vue&type=template&id=2f12e8c4&scoped=true"
import script from "./createNxOrder3.vue?vue&type=script&lang=js"
export * from "./createNxOrder3.vue?vue&type=script&lang=js"
import style0 from "./createNxOrder3.vue?vue&type=style&index=0&id=2f12e8c4&prod&scoped=true&lang=css"
import style1 from "./createNxOrder3.vue?vue&type=style&index=1&id=2f12e8c4&prod&lang=css"
import style2 from "./createNxOrder3.vue?vue&type=style&index=2&id=2f12e8c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12e8c4",
  null
  
)

export default component.exports